import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconButton, Tooltip } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { initialMainRoute } from "./routesConstants";

export function isMainPagePath(pathname: string) {
  const mainPath = `/${initialMainRoute}`;
  return (
    pathname === "/" ||
    pathname === mainPath ||
    pathname.startsWith(`${mainPath}/`)
  );
}

export default function BreadcrumbBackButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const mainPath = `/${initialMainRoute}`;

  if (isMainPagePath(pathname)) return null;

  const handleBack = () => {
    const historyIndex = window.history.state?.idx;
    if (typeof historyIndex === "number" && historyIndex > 0) {
      navigate(-1);
    } else {
      navigate(mainPath, { replace: true });
    }
  };

  return (
    <Tooltip title="Înapoi" arrow>
      <IconButton
        type="button"
        aria-label="Înapoi"
        onClick={handleBack}
        className="!h-[44px] !w-[44px] shrink-0 !rounded-lg !bg-surface-subtle !text-muted-dark hover:!bg-surface-hover focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2 focus-visible:!outline-accent">
        <ArrowBackRoundedIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Tooltip>
  );
}
